module.exports = __webpack_public_path__ + "static/media/resource-exercise.1a816782.png";